export default "__VITE_ASSET__82592da8__"